import { render, staticRenderFns } from "./Top100LabelsForm.vue?vue&type=template&id=3a2f4169"
import script from "./Top100LabelsForm.vue?vue&type=script&lang=js"
export * from "./Top100LabelsForm.vue?vue&type=script&lang=js"
import style0 from "./Top100LabelsForm.vue?vue&type=style&index=0&id=3a2f4169&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.22_cache-loader@4.1.0_webpack@4.47.0__css-load_8ff5e82d1052802783b01bda34c69ff2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports